function getIntlTimeZones(language: string = navigator.language) {
  try {
    const intlTimeZones = window.Intl.supportedValuesOf('timeZone')

    return intlTimeZones.map(timeZone => {
      const [, offset] = new Intl.DateTimeFormat(language, {timeStyle: 'long', timeZone})
        .format()
        .split(' ')

      return {
        name: timeZone,
        offset,
      }
    })
  } catch (e) {
    return []
  }
}

export default getIntlTimeZones
